import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 30 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 30 25\" id=\"arrow\">\n    <path fill-rule=\"evenodd\" fill=\"rgb(222, 179, 108)\" d=\"M17.585,24.113 L15.659,22.033 L24.337,13.920 L0.957,13.920 L0.957,11.080 L24.331,11.080 L15.659,2.970 L17.585,0.890 L29.996,12.503 L17.585,24.113 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol